/**
 * Country-code classifications derived from ISOCountryCode.
 *
 * `NATIONALITY_COUNTRY_CODES`
 *   Countries/states for which a nationality/citizenship value normally
 *   makes sense in user-facing forms.
 */

import { ISOCountryCode } from './ISOCountryCode';

export const NATIONALITY_COUNTRY_CODES = [
  ISOCountryCode.Afghanistan,
  ISOCountryCode.Albania,
  ISOCountryCode.Algeria,
  ISOCountryCode.Andorra,
  ISOCountryCode.Angola,
  ISOCountryCode.AntiguaAndBarbuda,
  ISOCountryCode.Argentina,
  ISOCountryCode.Armenia,
  ISOCountryCode.Australia,
  ISOCountryCode.Austria,
  ISOCountryCode.Azerbaijan,

  ISOCountryCode.Bahamas,
  ISOCountryCode.Bahrain,
  ISOCountryCode.Bangladesh,
  ISOCountryCode.Barbados,
  ISOCountryCode.Belarus,
  ISOCountryCode.Belgium,
  ISOCountryCode.Belize,
  ISOCountryCode.Benin,
  ISOCountryCode.Bhutan,
  ISOCountryCode.Bolivia,
  ISOCountryCode.BosniaHerzegovina,
  ISOCountryCode.Botswana,
  ISOCountryCode.Brazil,
  ISOCountryCode.BruneiDarussalam,
  ISOCountryCode.Bulgaria,
  ISOCountryCode.BurkinaFaso,
  ISOCountryCode.Burundi,

  ISOCountryCode.Cambodia,
  ISOCountryCode.Cameroon,
  ISOCountryCode.Canada,
  ISOCountryCode.CapeVerde,
  ISOCountryCode.CentralAfricanRepublic,
  ISOCountryCode.Chad,
  ISOCountryCode.Chile,
  ISOCountryCode.China,
  ISOCountryCode.Colombia,
  ISOCountryCode.Comoros,
  ISOCountryCode.RepublicCongo,
  ISOCountryCode.DemocraticRepublicCongo,
  ISOCountryCode.CostaRica,
  ISOCountryCode.IvoryCoast,
  ISOCountryCode.Croatia,
  ISOCountryCode.Cuba,
  ISOCountryCode.Cyprus,
  ISOCountryCode.Czechia,

  ISOCountryCode.Denmark,
  ISOCountryCode.Djibouti,
  ISOCountryCode.Dominica,
  ISOCountryCode.DominicanRepublic,

  ISOCountryCode.Ecuador,
  ISOCountryCode.Egypt,
  ISOCountryCode.ElSalvador,
  ISOCountryCode.EquatorialGuinea,
  ISOCountryCode.Eritrea,
  ISOCountryCode.Estonia,
  ISOCountryCode.Ethiopia,
  ISOCountryCode.Eswatini,

  ISOCountryCode.Fiji,
  ISOCountryCode.Finland,
  ISOCountryCode.France,

  ISOCountryCode.Gabon,
  ISOCountryCode.Gambia,
  ISOCountryCode.Georgia,
  ISOCountryCode.Germany,
  ISOCountryCode.Ghana,
  ISOCountryCode.Greece,
  ISOCountryCode.Grenada,
  ISOCountryCode.Guatemala,
  ISOCountryCode.Guinea,
  ISOCountryCode.GuineaBissau,
  ISOCountryCode.Guyana,

  ISOCountryCode.Haiti,
  ISOCountryCode.Vatican,
  ISOCountryCode.Honduras,
  ISOCountryCode.Hungary,

  ISOCountryCode.Iceland,
  ISOCountryCode.India,
  ISOCountryCode.Indonesia,
  ISOCountryCode.Iran,
  ISOCountryCode.Iraq,
  ISOCountryCode.Ireland,
  ISOCountryCode.Israel,
  ISOCountryCode.Italy,

  ISOCountryCode.Jamaica,
  ISOCountryCode.Japan,
  ISOCountryCode.Jordan,

  ISOCountryCode.Kazakhstan,
  ISOCountryCode.Kenya,
  ISOCountryCode.Kiribati,
  ISOCountryCode.NorthKorea,
  ISOCountryCode.SouthKorea,
  ISOCountryCode.Kuwait,
  ISOCountryCode.Kyrgyzstan,

  ISOCountryCode.Lao,
  ISOCountryCode.Latvia,
  ISOCountryCode.Lebanon,
  ISOCountryCode.Lesotho,
  ISOCountryCode.Liberia,
  ISOCountryCode.Libya,
  ISOCountryCode.Liechtenstein,
  ISOCountryCode.Lithuania,
  ISOCountryCode.Luxembourg,

  ISOCountryCode.Madagascar,
  ISOCountryCode.Malawi,
  ISOCountryCode.Malaysia,
  ISOCountryCode.Maldives,
  ISOCountryCode.Mali,
  ISOCountryCode.Malta,
  ISOCountryCode.MarshallIslands,
  ISOCountryCode.Mauritania,
  ISOCountryCode.Mauritius,
  ISOCountryCode.Mexico,
  ISOCountryCode.Micronesia,
  ISOCountryCode.Moldova,
  ISOCountryCode.Monaco,
  ISOCountryCode.Mongolia,
  ISOCountryCode.Montenegro,
  ISOCountryCode.Morocco,
  ISOCountryCode.Mozambique,
  ISOCountryCode.Myanmar,

  ISOCountryCode.Namibia,
  ISOCountryCode.Nauru,
  ISOCountryCode.Nepal,
  ISOCountryCode.Netherlands,
  ISOCountryCode.NewZealand,
  ISOCountryCode.Nicaragua,
  ISOCountryCode.Niger,
  ISOCountryCode.Nigeria,
  ISOCountryCode.NorthMacedonia,
  ISOCountryCode.Norway,

  ISOCountryCode.Oman,

  ISOCountryCode.Pakistan,
  ISOCountryCode.Palau,
  ISOCountryCode.Palestine,
  ISOCountryCode.Panama,
  ISOCountryCode.PapuaNewGuinea,
  ISOCountryCode.Paraguay,
  ISOCountryCode.Peru,
  ISOCountryCode.Philippines,
  ISOCountryCode.Poland,
  ISOCountryCode.Portugal,

  ISOCountryCode.Qatar,

  ISOCountryCode.Romania,
  ISOCountryCode.Russia,
  ISOCountryCode.Rwanda,

  ISOCountryCode.SaintKittsNevis,
  ISOCountryCode.SaintLucia,
  ISOCountryCode.SaintVincentGrenadines,
  ISOCountryCode.Samoa,
  ISOCountryCode.SanMarino,
  ISOCountryCode.SaoTomePrincipe,
  ISOCountryCode.SaudiArabia,
  ISOCountryCode.Senegal,
  ISOCountryCode.Serbia,
  ISOCountryCode.Seychelles,
  ISOCountryCode.SierraLeone,
  ISOCountryCode.Singapore,
  ISOCountryCode.Slovakia,
  ISOCountryCode.Slovenia,
  ISOCountryCode.SolomonIslands,
  ISOCountryCode.Somalia,
  ISOCountryCode.SouthAfrica,
  ISOCountryCode.SouthSudan,
  ISOCountryCode.Spain,
  ISOCountryCode.SriLanka,
  ISOCountryCode.Sudan,
  ISOCountryCode.Suriname,
  ISOCountryCode.Sweden,
  ISOCountryCode.Switzerland,
  ISOCountryCode.SyrianArabRepublic,

  ISOCountryCode.Tajikistan,
  ISOCountryCode.Tanzania,
  ISOCountryCode.Thailand,
  ISOCountryCode.TimorLeste,
  ISOCountryCode.Togo,
  ISOCountryCode.Tonga,
  ISOCountryCode.TrinidadTobago,
  ISOCountryCode.Tunisia,
  ISOCountryCode.Turkey,
  ISOCountryCode.Turkmenistan,
  ISOCountryCode.Tuvalu,

  ISOCountryCode.Uganda,
  ISOCountryCode.Ukraine,
  ISOCountryCode.UnitedArabEmirates,
  ISOCountryCode.UnitedKingdom,
  ISOCountryCode.UnitedStatesAmerica,
  ISOCountryCode.Uruguay,
  ISOCountryCode.Uzbekistan,

  ISOCountryCode.Vanuatu,
  ISOCountryCode.Venezuela,
  ISOCountryCode.Vietnam,

  ISOCountryCode.Yemen,

  ISOCountryCode.Zambia,
  ISOCountryCode.Zimbabwe,
] as const satisfies readonly ISOCountryCode[];

/**
 * Helpers.
 */
const NATIONALITY_COUNTRY_CODE_SET = new Set<ISOCountryCode>(
  NATIONALITY_COUNTRY_CODES,
);

export function isNationalityCountryCode(code: ISOCountryCode): boolean {
  return NATIONALITY_COUNTRY_CODE_SET.has(code);
}
